/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { faker } from '@faker-js/faker/locale/en';
import { RECOMMENDED_RUNTIME_IMAGE } from '../../../constants/RuntimeImage.constants';
import { CreateJobRequest } from '../Job';

export const createMockCreateJobRequest = (partialRecord: Partial<CreateJobRequest> = {}): CreateJobRequest => {
  const version = Array.from({ length: 3 })
    .map(() => faker.number.int())
    .join('.');

  return {
    name: faker.lorem.word(),
    description: faker.lorem.sentence(),
    version,
    image: RECOMMENDED_RUNTIME_IMAGE,
    ...partialRecord,
  };
};
